import cleanUpResponse from '@/util/cleanUpResponse';

export default async function SaveMFDRelocationDeliverySchedules(formData) {
  const response = await $.soap({
    body: {
      SaveMFDRelocationDeliverySchedules: {
        $xmlns: 'http://dla.mil/ems/bpm/order/customer_order_delivery_schedule',
        ToColl: formData.toColl,
        FromColl: formData.fromColl,
        OrderId: formData.orderId
      }
    },
    blueprint: {
      savedId: '$..ID'
    }
  });

  cleanUpResponse(response);
  return response.savedId;
}